import React from 'react';
import { withRouter } from 'react-router-dom';
import { shape } from 'prop-types';
import { Grid, Header, Segment } from 'semantic-ui-react';

import PageWrap from './PageWrap';
import PasswordForgetForm from './PasswordForgetForm';

const PasswordForget = ({ history }) => (
  <PageWrap>
    <div className="password-form">
      <style>{`
      body > div,
      body > div > div,
      body > div > div > div.password-form {
        height: 100%;
      }
    `}</style>
      <Grid
        textAlign="center"
        style={{ height: '100%' }}
        verticalAlign="middle"
      >
        <Grid.Column style={{ maxWidth: 450 }}>
          <Segment>
            <Header as="h2" color="blue" textAlign="center">
              Forgot Password
            </Header>
            <PasswordForgetForm history={history} />
          </Segment>
        </Grid.Column>
      </Grid>
    </div>
  </PageWrap>
);

PasswordForget.propTypes = {
  history: shape().isRequired,
};

export default withRouter(PasswordForget);



// WEBPACK FOOTER //
// ./src/components/PasswordForget.jsx